export default {"src":"/_next/static/media/ANDROID.7ad5a604.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};